export default "/images/vendor/flag-icon-css/flags/4x3/la.svg?8d6ad26b7061bc0588921e7a978bdac1";